import styled from "styled-components";

export const ImgTemplates = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  display: grid;
  grid-template-areas:
    "HD"
    "CT";
  grid-template-rows: 56px auto;
  background: ${(props) => props.theme.colors.mainBg};
`;

export const ContentsSection = styled.section<any>`
  grid-area: CT;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding: ${(props) => (props.padding ? props.padding : "16px")};
  background: ${(props) => (props.background ? props.background : "none")};
  gap: ${(props) => (props.gap ? props.gap : "40px")};
`;
